import { observer } from 'mobx-react-lite';
import { useContent } from '@/stores/RootStore';
import { useReveal } from '@/hooks/useReveal';
import SectionHeader from '@/components/ui/SectionHeader';
import LogoCarousel from '@/components/ui/LogoCarousel';
import s from './Clients.module.scss';

// 주요 거래처 — Trust(인증·협력 기관)와 "동일한 단일행 스텝 캐러셀 + 좌우 버튼"(사용자 지시 2026-07-31).
//   캐러셀은 공통 LogoCarousel 재사용. 유일한 구별점 = 섹션 배경 회색(gray-light)으로 Trust(흰색)와 분리.
const Clients = observer(() => {
  const { clients } = useContent();
  const reveal = useReveal<HTMLDivElement>();
  return (
    <section className={s.section}>
      <div className={s.inner} ref={reveal}>
        <SectionHeader title={clients.title} tagline={clients.tagline} divider className="anim-scroll" />
        <LogoCarousel logos={clients.items} />
      </div>
    </section>
  );
});

export default Clients;
